// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3jWk-","colCheckbox":"styles_colCheckbox__1XoWm"};